// ApiClient.ts
/* eslint-disable @typescript-eslint/no-explicit-any */
import HttpClient, { IDictionary } from '../lib/http-client'; // Убедитесь, что путь к HttpClient правильный
import config from '../boot/config'; // Убедитесь, что путь к конфигу правильный
import { IApiResponseGenericDTO } from '@common-frontend-submodule/interfaces/common/iapi-response.interface';

// Проверка наличия service_url в конфиге
if (!config.main.service_url) throw new Error('Error, parameter is not specified, check config file parameter: service_url');

class ApiClient {
    private static instance: ApiClient;
    private httpClient: HttpClient;

    private constructor() {
        this.httpClient = new HttpClient();
    }

    public static getInstance(): ApiClient {
        if (!ApiClient.instance) {
            ApiClient.instance = new ApiClient();
        }
        return ApiClient.instance;
    }

    public async getRequest<TOut>(url: string, params?: IDictionary | null): Promise<IApiResponseGenericDTO<TOut>> {
        try {
            return await this.httpClient.get<TOut>(url, params);
        } catch (e) {
            throw new Error('Error in method getRequest');
        }
    }

    public async postRequest<TIn, TOut>(url: string, data: TIn, params?: IDictionary | null): Promise<IApiResponseGenericDTO<TOut>> {
        try {
            return await this.httpClient.post<TIn, TOut>(url, data, params);
        } catch (e) {
            throw new Error('Error in method postRequest');
        }
    }

    public async postBlob<TIn>(url: string, data: TIn, params?: IDictionary | null, filename? : string): Promise<void> {
        try {
            await this.httpClient.getBlob<TIn>(url, data, params, filename);
        } catch (e) {
            throw new Error('Не удалось получить данные');
        }
    }

    public async putRequest<TIn, TOut>(url: string, data: TIn, params?: IDictionary | null): Promise<IApiResponseGenericDTO<TOut>> {
        try {
            return await this.httpClient.put<TIn, TOut>(url, data, params);
        } catch (e) {
            throw new Error('Error in method putRequest');
        }
    }

    public async deleteRequest<TIn, TOut>(url: string, data?: TIn | null, params?: IDictionary | null): Promise<IApiResponseGenericDTO<TOut>> {
        try {
            return await this.httpClient.delete<TIn, TOut>(url, data, params);
        } catch (e) {
            throw new Error('Error in method deleteRequest');
        }
    }

    public async postFormDataRequest<TIn, TOut>(url: string, data: TIn, params?: IDictionary | null): Promise<IApiResponseGenericDTO<TOut>> {
        try {
            return await this.httpClient.postFormData<TIn, TOut>(url, data, params);
        } catch (e) {
            throw new Error('Error in method postFormDataRequest');
        }
    }
}

export default ApiClient;
